// =============================================================
// SEED DATA — replace emoji with real Cloudinary/S3 image URLs
// in production. The `image` field accepts a URL string.
// =============================================================

export const CATEGORIES = [
  'All',
  'Starters',
  'Noodles',
  'Rice',
  'Curries',
  'Soups',
  'Desserts',
  'Drinks',
];

export const SEED_MENU = [
  {
    id: 'm1',
    name: 'Pad Thai Classic',
    desc: 'Stir-fried rice noodles with eggs, bean sprouts, spring onions and your choice of chicken, prawns or tofu, finished with roasted peanuts and fresh lime.',
    category: 'Noodles',
    price: 175,
    emoji: '🍜',
    image: null,
    tags: ['bestseller'],
    active: true,
    soldOut: false,
    featured: true,
    spiceLevel: 1,
    prepMinutes: 12,
  },
  {
    id: 'm2',
    name: 'Green Curry',
    desc: 'Aromatic green curry simmered in coconut milk with Thai basil, bamboo shoots and your choice of chicken, beef or tofu. Served with jasmine rice.',
    category: 'Curries',
    price: 185,
    emoji: '🥘',
    image: null,
    tags: ['spicy', 'bestseller'],
    active: true,
    soldOut: false,
    featured: true,
    spiceLevel: 2,
    prepMinutes: 15,
  },
  {
    id: 'm3',
    name: 'Tom Yum Soup',
    desc: "Thailand's iconic hot and sour broth with lemongrass, galangal, kaffir lime leaves, mushrooms and plump prawns.",
    category: 'Soups',
    price: 155,
    emoji: '🍲',
    image: null,
    tags: ['spicy', 'new'],
    active: true,
    soldOut: false,
    featured: false,
    spiceLevel: 2,
    prepMinutes: 10,
  },
  {
    id: 'm4',
    name: 'Massaman Curry',
    desc: 'Rich slow-cooked curry with tender beef, potatoes, onions and roasted peanuts in a fragrant coconut milk sauce. Mild and deeply satisfying.',
    category: 'Curries',
    price: 195,
    emoji: '🫕',
    image: null,
    tags: ['bestseller'],
    active: true,
    soldOut: false,
    featured: true,
    spiceLevel: 0,
    prepMinutes: 15,
  },
  {
    id: 'm5',
    name: 'Pad See Ew',
    desc: 'Wide rice noodles wok-fried with egg, Chinese broccoli and a rich, slightly sweet soy-based sauce. Comfort food done right.',
    category: 'Noodles',
    price: 170,
    emoji: '🍝',
    image: null,
    tags: [],
    active: true,
    soldOut: false,
    featured: false,
    spiceLevel: 0,
    prepMinutes: 12,
  },
  {
    id: 'm6',
    name: 'Mango Sticky Rice',
    desc: 'Fragrant glutinous rice served warm with fresh ripe mango and a drizzle of sweet coconut cream. A classic Thai dessert.',
    category: 'Desserts',
    price: 95,
    emoji: '🥭',
    image: null,
    tags: ['veg', 'bestseller'],
    active: true,
    soldOut: false,
    featured: true,
    spiceLevel: 0,
    prepMinutes: 5,
  },
  {
    id: 'm7',
    name: 'Som Tum Papaya Salad',
    desc: 'Shredded green papaya tossed with cherry tomatoes, green beans, peanuts, lime juice and fresh chilli. Bright, crunchy and addictive.',
    category: 'Starters',
    price: 120,
    emoji: '🥗',
    image: null,
    tags: ['veg', 'spicy'],
    active: true,
    soldOut: false,
    featured: false,
    spiceLevel: 2,
    prepMinutes: 8,
  },
  {
    id: 'm8',
    name: 'Thai Fish Cakes',
    desc: 'Golden-fried fish cakes seasoned with red curry paste, kaffir lime and green beans, served with sweet chilli dipping sauce.',
    category: 'Starters',
    price: 135,
    emoji: '🐟',
    image: null,
    tags: ['bestseller'],
    active: true,
    soldOut: false,
    featured: false,
    spiceLevel: 1,
    prepMinutes: 10,
  },
  {
    id: 'm9',
    name: 'Red Curry',
    desc: 'Vibrant red curry with coconut milk, bell peppers, bamboo shoots and fragrant Thai basil. Available with chicken, prawns or vegetables.',
    category: 'Curries',
    price: 180,
    emoji: '🍛',
    image: null,
    tags: ['spicy'],
    active: true,
    soldOut: false,
    featured: false,
    spiceLevel: 2,
    prepMinutes: 15,
  },
  {
    id: 'm10',
    name: 'Thai Iced Tea',
    desc: 'Creamy, sweet Thai tea brewed strong and poured over ice with evaporated and condensed milk. Refreshing and indulgent.',
    category: 'Drinks',
    price: 65,
    emoji: '🧋',
    image: null,
    tags: ['veg', 'bestseller'],
    active: true,
    soldOut: false,
    featured: false,
    spiceLevel: 0,
    prepMinutes: 3,
  },
  {
    id: 'm11',
    name: 'Crispy Spring Rolls',
    desc: 'Perfectly crispy rolls filled with glass noodles, wood-ear mushrooms and fresh vegetables, served with plum sauce.',
    category: 'Starters',
    price: 110,
    emoji: '🥙',
    image: null,
    tags: ['veg'],
    active: true,
    soldOut: false,
    featured: false,
    spiceLevel: 0,
    prepMinutes: 8,
  },
  {
    id: 'm12',
    name: 'Khao Pad Fried Rice',
    desc: 'Jasmine rice wok-tossed with egg, fresh vegetables and soy sauce. A satisfying everyday classic, available with any protein.',
    category: 'Rice',
    price: 160,
    emoji: '🍚',
    image: null,
    tags: [],
    active: true,
    soldOut: false,
    featured: false,
    spiceLevel: 0,
    prepMinutes: 10,
  },
  {
    id: 'm13',
    name: 'Pineapple Fried Rice',
    desc: 'Thai fried rice with fresh pineapple chunks, cashews, raisins and a hint of curry powder. Served in a pineapple half.',
    category: 'Rice',
    price: 175,
    emoji: '🍍',
    image: null,
    tags: ['veg', 'new'],
    active: true,
    soldOut: false,
    featured: false,
    spiceLevel: 0,
    prepMinutes: 12,
  },
  {
    id: 'm14',
    name: 'Coconut Water',
    desc: 'Fresh chilled coconut water, naturally sweet and hydrating. Sourced locally from Seychelles coconuts.',
    category: 'Drinks',
    price: 55,
    emoji: '🥥',
    image: null,
    tags: ['veg'],
    active: true,
    soldOut: false,
    featured: false,
    spiceLevel: 0,
    prepMinutes: 1,
  },
];

export const SEED_REVIEWS = [
  {
    id: 'rv1',
    name: 'Sophie M.',
    rating: 5,
    text: 'Absolutely incredible Pad Thai! Reminds me of my travels through Bangkok. I ordered at the kiosk, paid and collected in under 10 minutes. Will be back every week!',
    date: '2026-03-14',
  },
  {
    id: 'rv2',
    name: 'James K.',
    rating: 5,
    text: 'The Green Curry is the best I have had outside of Thailand. Perfectly balanced heat and creamy coconut. Ordering online is genius, no waiting around at all.',
    date: '2026-04-02',
  },
  {
    id: 'rv3',
    name: 'Marie-Anne D.',
    rating: 4,
    text: 'Amazing food and great service. The Massaman Curry was rich and hearty. Ordering online meant my food was ready the moment I arrived. Highly recommend!',
    date: '2026-02-28',
  },
];

// ---------------------------------------------------------------
// MongoDB schema reference (for production backend)
// ---------------------------------------------------------------
//
// Collection: menuItems
// {
//   _id: ObjectId,
//   name: String,
//   desc: String,
//   category: String,
//   price: Number,            // SCR
//   emoji: String,
//   imageUrl: String,         // Cloudinary / S3 URL
//   tags: [String],           // 'bestseller' | 'spicy' | 'veg' | 'new'
//   active: Boolean,          // today's availability toggle
//   soldOut: Boolean,         // sold-out toggle (visible but unavailable)
//   featured: Boolean,        // appears in Today's Specials
//   spiceLevel: Number,       // 0 = none, 1 = mild, 2 = hot
//   prepMinutes: Number,      // estimated prep time
//   createdAt: Date,
//   updatedAt: Date,
// }
//
// Collection: orders
// {
//   _id: ObjectId,
//   orderId: String,          // human-readable e.g. TE-20260416-001
//   name: String,
//   phone: String,
//   email: String,
//   items: [{
//     itemId: ObjectId,
//     name: String,
//     price: Number,
//     qty: Number,
//     notes: String,
//   }],
//   pickupTime: Date,
//   subtotal: Number,
//   total: Number,
//   paymentStatus: String,    // 'pending' | 'paid' | 'refunded'
//   paymentRef: String,       // payment gateway reference
//   status: String,           // 'new' | 'preparing' | 'ready' | 'collected'
//   notes: String,
//   createdAt: Date,
// }
//
// Collection: reviews
// { _id, name, rating, text, date, approved, createdAt }
